const TRANSLATION_EN = {
    0: 0,
    cancel: 'Cancel',
    delete: 'Delete',
    howAreYouToday: 'How are you today?',
    selectEmotion: 'Select emotion',
    question: 'Question',
    settings: 'Settings',
    privacyPolicy: 'Privacy policy',
    dayReview: 'Day review',
    dailyReflection: 'Daily Reflection',
    like: 'Like',
    showLess: 'Show Less',
    showMore: 'Show More',
    search: 'Search',
    years: 'Years',
    year: 'Year',
    classes: 'Classes',
    class: 'Class',
    custom: 'Custom',
    staff: 'Staff',
    allStudents: 'All students',
    beAmazing: 'Be amazing!',
    login: 'Login',
    getStarted: 'Get started',
    password: 'Password',
    email: 'Email',
    requestNewPassword: 'Request new password',
    newPassword: 'New password',
    enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: "Enter your school email and we'll send you a validation token to get back into your account",
    sendRequest: 'Send request',
    verifyYourEmail: 'Verify your email',
    weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere:
        "We've sent you a validation token to get back into your account. Check your mail and copy your token here.",
    resendARequest: 'Resend a request',
    didntGetAMail: "Didn't get a mail?",
    submit: 'Submit',
    poll: 'Poll',
    title: 'Title',
    message: 'Message',
    anonymous: 'Anonymous',
    excellentWorkWeAreDelightedToHearThingsAreSoMuchBetter: 'Excellent work! We’re delighted to hear things are so much better.',
    thisIsYourSafePlaceAndNothingWillBeShared: 'This is your safe place. Nothing will be shared.',
    enterANameForTodaysNotes: "Enter a name for today's notes.",
    iDontWantToSaveNotes: 'I don’t want to save notes',
    worse: 'Worse',
    sorryToHearThatThingsAreWorse: 'Sorry to hear that things are worse.',
    sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow: 'Sorry to hear that things are worse. Which of the following would help right now?',
    muchWorse: 'Much worse',
    feelingMuchWorseQuestion: "We're sorry to hear that you're feeling worse. Which of the suggestions below can help you right now?",
    sorryToHearThatThingsAreMuchWorse: 'Sorry to hear that things are much worse.',
    same: 'Same',
    feelingSameQuestion: 'What can you do right now to make your situation better?',
    better: 'Better',
    feelingBetterQuestion: 'Nice to hear that the situation has improved. Do you have ideas on how you could possibly make it even better?',
    goodToHearThingsAreBetter: 'Good to hear things are better.',
    muchBetter: 'Much better',
    greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel:
        'Great to hear things are much better. Think about how to improve even more or keep it on a positive level',
    suggestions: 'Suggestions',
    loadMoreSuggestions: 'Load more suggestions',
    continue: 'Continue',
    deleteNote: 'DELETE NOTE',
    today: 'Today',
    comparedToLastTimeTodayIamFeeling: "Compared to last time, today I'm feeling",
    howDoYouFeelComparedToLastTimeYouDidThePoll: 'How do you feel compared to last time you did the poll?',
    thisInformationWillBeSharedWith: 'This information will be shared with teacher.',
    feelFreeToShareAnyThoughtsHereWhyYouFeelThisWay: 'Feel free to share any thoughts here why you feel this way',
    feedback: 'Feedback',
    choose: 'Choose',
    openTasks: 'Open Tasks',
    newConversation: 'New conversation',
    teacher: 'Teacher',
    counselor: 'Counsellor',
    secretKey: 'Secret key',
    advancedSettings: 'Advanced settings',
    termsAndConditions: 'Terms & Conditions',
    appVersion: 'App version: ',
    surname: 'Surname',
    firstName: 'First Name',
    thisIsYourPrivateRoom: 'This is your private room.',
    safePlaceWithDailyReflectionNotes: 'Safe place with daily reflection notes',
    personalInformation: 'Personal information',
    privacyAndSecurity: 'Privacy and security',
    open: 'Open',
    openLink: 'Open link',
    tasks: 'Tasks',
    logout: 'Logout',
    save: 'Save',
    name: 'Name',
    profile: 'Profile',
    feed: 'Feed',
    Yes: 'Yes',
    No: 'No',
    archive: 'Archive',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    results: 'Results',
    required: 'Required',
    schedule: 'Schedule',
    happy: 'happy',
    ecstatic: 'ecstatic',
    inspired: 'inspired',
    calm: 'calm',
    good: 'good',
    woried: 'woried',
    numb: 'numb',
    lethargic: 'lethargic',
    grumpy: 'grumpy',
    sad: 'sad',
    stressed: 'stressed',
    angry: 'angry',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    delivered: 'Delivered',
    seen: 'Seen',
    forgotPassword: 'Forgot password?',
    repeatPassword: 'Repeat password',
    retypePassword: 'Retype password',
    changePassword: 'Change password',
    dailyFeedback: 'Daily Feedback',
    enterSurname: 'Enter surname',
    newMessage: 'New message!',
    myTasks: 'My Tasks',
    hi: 'Hi',
    comment: 'Comment',
    passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol:
        'Password must be longer than 8 characters, must contains uppercase, lowercase, number and special symbol',
    enterYourWorkEmailAndPassword: 'Enter your school email and password',
    submitNewPassword: 'Submit new password',
    writeYourMessageHere: 'Write your message here',
    saveAndContinue: 'Save and continue',
    whatAreJust3GoodThingsThatHappenedToday: 'What are just 3 good things that happened today?',
    secretKeyHasBeenSaved: 'Secret key has been saved',
    enterSecretKey: 'Enter secret keys',
    passwordsDoNotMatch: 'Passwords do not match',
    howWasYourDay: 'How was your day?',
    thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices:
        'Thank you for reaching out. We will reply to your message soon.',
    doYouThinkThingsAreForAnyReasonInParticular: 'Do you think things feel {{result}} for any reason in particular?',
    yourPrivateNotes: 'Your private notes',
    iDontWantToThinkAboutThisNow: "I don't want to think about this now",
    selectLanguage: 'Select language',
    userIsUpdated: 'User is updated',
    privateNoteHasBeenSaved: 'Private note has been saved',
    writePersonalNotesHere: 'Write your personal notes here (only you can see this)',
    compareToLastTime: 'Compare to last time',
    yourAnswerIsSaved: 'Your answer is saved',
    staySecuredFirst: 'Stay secured first',
    Surveys: 'Surveys',
    survey: 'Survey',
    Section: 'Section',
    Sections: 'Sections',
    youHaveNoChats: 'You have no chats',
    sos: 'SOS',
    open_survey: 'Open survey',
    anonymous_survey: 'Anonymous survey',
    'Take Survey': 'Take Survey',
    nameOfTodayNote: 'Name of today note',
    experienceIt: '% experience it',
    read: 'read',
    received: 'received',
    Received: 'Received',
    Attention: 'Attention',
    toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey:
        'To ensure your privacy, this key is not recoverable. All your notes will be lost if you forget this key!',
    anonymousPoll: 'Anonymous poll',
    Previous: 'Previous',
    anonymousQuestion: 'Anonymous question',
    openQuestion: 'Open question',
    open_poll: 'Open poll',
    anonymous_poll: 'Anonymous poll',
    solutions: 'Solutions',
    chat: 'Chat',
    time: 'Time',
    congratsEverythingIsDoneForNowWaitForNewTasks: 'Congrats, everything is done for now! Wait for new tasks...',
    date: 'Date',
    'Write full answer here': 'Write full answer here',
    'My Upstrive': 'My Upstrive',
    'Select emotion that fits your mood': 'Select emotion that fits your mood',
    'Select one option': 'Select one option',
    youHaveMissedThisQuestion: 'You have missed this question',
    'Next section': 'Next section',
    Finish: 'Finish',
    'Your results are saved!': 'Your results are saved!',
    yourAnswersAreSaved: 'Your answers are saved!',
    openJournal: 'Open journal',
    day: 'Day',
    'Your browser does not support HTML video': 'Your browser does not support HTML video',
    typeYourAnswerHere: 'Type your answer here',
    'We hope you’ve had a good day!': 'We hope you’ve had a good day!',
    'What are 3 things that are a bit challenging at the moment?': 'What are 3 things that are a bit challenging at the moment?',
    'What’s just one thing you will do differently tomorrow?': 'What’s just one thing you will do differently tomorrow?',
    'What`s the main reason?': 'What`s the main reason?',
    'Note has been deleted': 'Note has been deleted',
    'At least 8 characters': 'At least 8 characters',
    confirmDeletion: 'Confirm deletion',
    'Select an emotion that describes how you’re feeling': 'Select an emotion that describes how you’re feeling',
    'Language is changed': 'Language is changed',
    rememberMe: 'Remember me',
    showPassword: 'Show password',
    instructionVideo: 'Instruction Video',
    instructionVideos: 'Instruction Videos',
    yourTasks: 'Your tasks',
    activitiesForCompletion: 'Activities for completion',
    oopsThereSeemsToBeAnIssueWithConnection: 'Oops there seems to be an issue with connection',
    pleaseTryAgainInAFewMinutestOrContactUpstriveSupport: 'Please try again in a few minutes or contact Upstrive Support',
    loadingMoreFeeds: 'Loading more feeds',
    chooseTheAnswer: 'Choose the answer',
    writeFullAnswerHere: 'write the full answer here',
    selectEmotionThatBestDescribesYourMoodToday: 'Select an emotion that best describes your mood today',
    yourBrowserDoesNotSupportHTMLVideo: 'Your browser does not support HTML video.',
    whatIsTheMainReason: 'What’s the main reason?',
    pickUpTo3: 'Pick up to 3',
    myself: 'myself',
    family: 'family',
    friends: 'friends',
    school: 'school',
    'social media': 'social media',
    wellbeing: 'wellbeing',
    health: 'health',
    achievement: 'achievement',
    sleep: 'sleep',
    typeAnyAdditionalTextHere: 'Type any additional text here',
    howDoYouFeelComparedToLastTimeYouLoggedIn: 'How do you feel compared to the last time you logged in?',
    iDontWantToThinkAboutItNow: 'I don’t want to think about it now',
    stepBack: 'Step back',
    writeYourPersonalNotesHere: 'Write your personal notes here (only you can see this)',
    whatCouldYouDoToImproveThingsRightNow: 'What could you do to improve things right now?',
    selectOneOption: 'Select one option',
    finish: 'Finish',
    nextSection: 'Next section',
    iHaveAnIssueRelatedTo: 'I have an issue related to...',
    sorryYourSchoolRestrictedAccessToThisModule: 'Sorry your school restricted access to this module.',
    findTheRightSolution: 'Find the right solution',
    exploreThingsYouCanDoRightNow: 'Explore things you can do right now',
    seeHowOtherStudentsHandleThis: 'See how other students handle this',
    connectWithTheConselor: 'Connect with counsellor',
    quickTips: 'Quick tips',
    howToDealWithThisProblem: 'How to deal with this problem?',
    thingsYouCanDoRightNow: 'Things you can do right now',
    yesThanks: 'Yes Thanks!',
    notReally: 'Not really',
    expertRecommendation: 'Expert recommendation',
    wasThisSolutionHelpful: 'Was this solution helpful?',
    send: 'Send',
    close: 'Close',
    topic: 'Topic',
    'I Care / I Listen': 'I Care / I Listen Chat',
    privateNotes: 'Private notes',
    yourSecretKeyIsSaved: 'Your secret key is saved',
    changeSecurityKey: 'Change security key',
    passwordSetup: 'Password setup',
    atLeast8Caracters: 'At least 8 caracters',
    mobileAndDesktopStudentVersion: 'Mobile and Desktop - Student Version.mp4',
    weHopeYouHaveAGoodDay: 'We hope you have a good day!',
    whatAre3ThingsThatAreABitChallengingAtTheMoment: 'What are three things that are a bit challenging at the moment?',
    whatsJustOneThingYouWillDoDifferentlyTomorrow: 'What is just one thing you will do differently tomorrow? ',
    typeOneThingHere: 'Type one thing here',
    'Type 1st thing here': 'Type 1st thing here',
    'Type 2nd thing here': 'Type 2nd thing here',
    'Type 3rd thing here': 'Type 3rd thing here',
    noteHasBeenDeleted: 'Note has been deleted',
    returnBack: 'Return back',
    yourResultsAreSaved: 'Your results are saved!',
    majorUpdate: 'Major Update',
    whatsNew: "What's new?",
    sameGreatAppFreshNewLook: 'Same great app fresh new look!',
    next: 'Next',
    closePopup: 'Close pop-up',
    completed: 'completed',
    'Your message is sent! Someone will contact you soon': 'Your message is sent! Someone will contact you soon',
    sec: 'sec',
    'You have been logged out automatically after 15 minutes': 'You have been logged out automatically after 15 minutes',
    'How are you?': 'How are you?',
    point: 'point',
    points: 'points',
    'You are doing great! You earned 5 points for completing survey': 'You are doing great! You earned {{value}} points for completing survey',
    'Next Video': 'Next Video',
    'Video topic': 'Video topic',
    'Your emotion is confirmed': 'Your emotion is confirmed',
    Success: 'Success',
    'Share your feedback': 'Share your feedback',
    'Leave your feedback': 'Leave your feedback',
    'Tell us how we can improve Upstrive in the box below': 'Tell us how we can improve Upstrive in the box below.',
    'Type your feedback here': 'Type your feedback here',

    Achievements: 'Achievements',
    'Dumo Points': 'Dumo Points',
    'Browse achievements': 'Browse achievements',
    'Achievements center': 'Achievements center',
    'Earn points by completing tasks and exchange them into rewards': 'Earn points by completing tasks and exchange them into rewards',
    '10 more points possible to earn today': '10 more points possible to earn today',
    'Check points system': 'Check points system',
    'Available points': 'Available points',
    'Our Achievements': 'Our Achievements',
    'Boost your points by earning achivements': 'Boost your points by earning achivements',
    'Daily Achievements': 'Daily Achievements',
    'Features achievements': 'Features achievements',
    'Our Rewards': 'Our Rewards',
    'Exchange your points into rewards': 'Exchange your points into rewards',
    'Transfer earned points to Dummo': 'Transfer earned points to Dummo',
    'Exchange for a reward': 'Exchange for a reward',
    'Task Description': 'Task Description',
    'Progress bar': 'Progress bar',
    'Select as goal': 'Select as goal',
    'Send earned points to DUMO': 'Select as goal',
    'Type your DUMO account here': 'Type your DUMO account here',
    'Amount of points you want to transfer': 'Amount of points you want to transfer',
    'Enter your DUMO account': 'Enter your DUMO account',
    Proceed: 'Proceed',
    'Points Earned': 'Points Earned',
    'This popup will be auto closed in': 'This popup will be auto closed in',
    'Anonymous chats': 'Anonymous chats',
    'Visible chats': 'Visible chats',
    'This message will be sent anonymously to your teacher, ensuring your privacy': 'This message will be sent anonymously to your teacher, ensuring your privacy',
    'Your opinion matters to us!': 'Your opinion matters to us!',
    'Your feedback helps us to improve. If you find our app helpful, please consider rating it.':
        'Your feedback helps us to improve. If you find our app helpful, please consider rating it.',

    'Thank you!': 'Thank you!',
    'Connect with Dummo account': 'Connect with Dummo account',
    'No item found': 'No item found',
    'Enter your DUMO username': 'Enter your DUMO username',
    'Write your Dummo username below': 'Write your Dummo username below',
    'Hi, connect your Dummo account': 'Hi, connect your Dummo account',
    Confirm: 'Confirm',
    'No, cancel': 'No, cancel',
    'Yes, unlink': 'Yes, unlink',
    'Transfer points': 'Transfer points',

    'Email does not exist': 'Email does not exist',
    'Your email address is not valid. Please ask your school admin for new password': 'Your email address is not valid. Please ask your school admin for new password',
    'Invalid token, Contact Support': 'Invalid token, Contact Support',
    'Please enter username and password': 'Please enter username and password',
    "We can't find an account with this email...": "We can't find an account with this email...",
    'Enter credentials you received from school': 'Enter credentials you received from school',
    'This is only for students...': 'This is only for students...',
    'Incorrect password.': 'Incorrect password.',
    'Thank you for helping us to make Upstrive better.': 'Thank you for helping us to make Upstrive better.',
    'Student Desktop Tutorial': 'Student Desktop Tutorial',
    'Learn how to get the best out of the desktop version of Upstrive by exploring all the features and functionalities this version has to offer.':
        'Learn how to get the best out of the desktop version of Upstrive by exploring all the features and functionalities this version has to offer.',
    'Student Mobile App Tutorial': 'Student Mobile App Tutorial',
    'Discover all the features, tips and tools to get the best out of your mobile application.':
        'Discover all the features, tips and tools to get the best out of your mobile application.',
    'Delete your private note?': 'Delete your private note?',
    'Invalid token': 'Invalid token',
    Myself: 'Myself',
    Family: 'Family',
    home: 'Home',
    Friends: 'Friends',
    'Social media': 'Social media',
    Wellbeing: 'Wellbeing',
    Health: 'Health',
    School: 'School',
    Achievement: 'Achievement',
    Sleep: 'Sleep',
    'Dummo account successfully connected': 'Dummo account successfully connected',
    'Dummo points successfully transfered': 'Dummo points successfully transfered',
    'This day is locked!': 'This day is locked!',
    'Finish later': 'Finish later',
    'You have missed this question': 'You have missed this question',
    'Day review': 'Day review',
    'Do not agree': 'Do not agree',
    "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!":
        "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!",
    'You will be logged out': 'You will be logged out',
    'I do not agree': 'I do not agree',
    Continue: 'Continue',
    "I confirm that I read and agree to Upstrive's": "I confirm that I read and agree to Upstrive's",
    'Terms and Conditions': 'Terms and Conditions',
    worried: 'worried',

    Confidential: 'Confidential',
    '1st': '1st',
    '2nd': '2nd',
    '3rd': '3rd',
    'Your journal is for you only — nobody can see what you write, but your teacher can see that you’re working on it':
        'Your journal is for you only — nobody can see what you write, but your teacher can see that you’re working on it.',
    'Start Journalling!': 'Start Journalling!',
    'Boost your points by earning achievements': 'Boost your points by earning achievements',
    visitOurWebsiteForMoreDetails: 'Visit our <white>website</white> for more details.',

    "I think I'm feeling this way because": "I think I'm feeling this way because ...",

    'Your Reflection Space': 'Your Reflection Space',
    'Go Back': 'Go Back',
    'Add your personal notes here - only you can see them': 'Add your personal notes here - only you can see them',
    'Stay Secure': 'Stay Secure',
    'Enter your secret key': 'Enter your secret key',
    "Name Today's Notes": "Name Today's Notes",
    "Enter a name for today's notes": "Enter a name for today's notes:",
    'Skip for now': 'Skip for now',
    "Today's Reflection": "Today's Reflection",
    'What are three good things that happened today?': 'What are three good things that happened today?',
    'Type your {{num}} thing here': 'Type your {{num}} thing here',
    'Do you think things feel the same for any reason in particular?': 'Do you think things feel {{compare}} for any reason in particular?',
    'ordinal.first': 'first',
    'ordinal.second': 'second',
    'ordinal.third': 'third',
    'ordinal.fourth': 'fourth',
    'ordinal.fifth': 'fifth',
    'ordinal.sixth': 'sixth',
    'ordinal.seventh': 'seventh',
    'ordinal.eighth': 'eighth',
    'ordinal.ninth': 'ninth',
    'ordinal.tenth': 'tenth',
    the: 'the',
    'We hope you had a good day!': 'We hope you had a good day!',
    'What are three things that are a bit challenging at the moment?': 'What are three things that are a bit challenging at the moment?',
    'Share your thoughts here': 'Share your thoughts here',
    'Create a new password': 'Create a new password',
    'Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special symbol.':
        'Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special symbol.',
    'Enter your new password': 'Enter your new password',
    'Re-enter your new password': 'Re-enter your new password',
    'Select your answer': 'Select your answer',
    //
    'Confirm new password': 'Confirm new password',
    'Add a short title for your message': 'Add a short title for your message',
    'Type your message here': 'Type your message here',
    'At least 8 characters (upper, lower, number & symbol)': 'At least 8 characters (upper, lower, number & symbol)',
    Counselor: 'Counsellor',
}

export default TRANSLATION_EN
